import React, { useEffect, useState } from 'react';

import { useDrawers } from 'hooks/useDrawers';
import { usePagination } from 'hooks/usePagination';
import { TribesService } from 'services/TribesService';
import { KATOService } from 'services/KATOService';
import { OKEDService } from 'services/OKEDService';
import { PartnersService } from 'services/PartnersService';

import { message } from 'antd';
import { FETCH_ERROR } from 'constants/alerts';

import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { formatDate } from 'utils';
import { TribesForm } from './TribesForm';
import { TribesTable } from './TribesTable';

function Tribes() {
  useDocumentTitle('Трайбы');
  const { setCount } = useHeaderChanger('Трайбы');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState({
    regions: [],
    activities: [],
    partners: [],
  });
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();

  useEffect(() => {
    fetchOptions();
  }, []);

  useEffect(() => {
    fetchTribes();
  }, [page, perPage]);

  const fetchTribes = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await TribesService.getTribes(page, perPage);

      setCount(total);
      setTotalRows(total);
      setItems(items);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const fetchOptions = async () => {
    try {
      const regionsPr = await KATOService.getAllKATO();
      const activitiesPr = await OKEDService.getAllOKED();
      const partnersPr = await PartnersService.getAllPartners();

      const [regions, activities, partners] = await Promise.all([
        regionsPr,
        activitiesPr,
        partnersPr,
      ]);

      setOptions({
        regions,
        activities,
        partners,
      });
    } catch (err) {
      message.error(
        'Не удалось загрузить данные для создания/редактирования трайбов'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="tribe" />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.title}
        pageId="tribe"
        recordFields={[
          { label: '№', key: 'id' },
          { label: 'Наименование', key: 'title' },
          {
            label: 'Создан',
            key: 'created',
            computedValue: formatDate(activeRecord?.created),
          },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
      />

      <TribesTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        totalRows={totalRows}
        onRowClick={openDrawer}
        onChange={setPagination}
      />

      <TribesForm
        isActive={formIsActive}
        initialValues={activeRecord}
        options={options}
        loading={loading}
        onSuccess={fetchTribes}
        onClose={closeForm}
      />
    </>
  );
}

export { Tribes };
